import * as React from 'react';
import Svg, { Rect, Path, Mask, G, Circle } from 'react-native-svg';

function SvgComponent(props: any) {
  return (
    <Svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <Rect x={8} y={18} width={2} height={9} rx={1} fill="#452A21" />
      <Rect
        x={14}
        y={26}
        width={2}
        height={10}
        rx={1}
        transform="rotate(90 14 26)"
        fill="#452A21"
      />
      <Path
        d="M3 6h12v6a6 6 0 0 1-12 0V6Z"
        stroke="#452A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <Mask id="a" x={15} y={14} width={16} height={14}>
        <Path
          d="M27.267 20.252a14.5 14.5 0 0 1 2.198 6.732H16.587l5.555-11.62a14.5 14.5 0 0 1 5.125 4.888Z"
          fill="#fff"
          stroke="#452A21"
          strokeWidth={2}
        />
      </Mask>
      <G mask="url(#a)">
        <Path
          d="M27.267 20.252a14.5 14.5 0 0 1 2.198 6.732H16.587l5.555-11.62a14.5 14.5 0 0 1 5.125 4.888Z"
          fill="#fff"
          stroke="#452A21"
          strokeWidth={2}
        />
        <Circle cx={22.5} cy={21.5} r={1.5} fill="#452A21" />
      </G>
      <Mask id="b" x={21} y={24} width={7} height={4}>
        <Path fill="#C4C4C4" d="M21 24h7v4h-7z" />
      </Mask>
      <G mask="url(#b)">
        <Circle cx={24.5} cy={27.5} r={2.5} fill="#fff" stroke="#452A21" strokeWidth={2} />
      </G>
    </Svg>
  );
}

export default SvgComponent;
